import { t } from '@lingui/macro';

import { usePaletteType } from '../../../utilities/ColorUtilities';
import { PANEL_CATEGORIES, COMPARISON_OVERLAY_PANEL_PREVIEW_IMAGE } from '../../page-framework/panel/PanelRegistry';
import {
    agentFilterId,
    businessServiceFilterId,
    siteFilterId,
    testTypeFilterId,
    timeRangeComparisonFilterId,
} from '../../filters';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import Panel from '../../page-framework/panel/PanelDecorator';
import {
    testComparisonDataSource,
    TestComparisonChart,
    useTestComparisonChartConfig,
} from '../../charts/test-comparison-chart/TestComparisonChart';
import {
    VARIANT_OVERLAY,
    useTestMetricOverlaySeries,
} from '../../charts/test-comparison-chart/TestComparisonChartHelper';

import usePanelDataService from '../../../services/PanelDataService';

const title = t`Service Test Comparison Overlay`;

function ServiceTestComparisonOverlayPanel() {
    const paletteType = usePaletteType();
    const rawData = usePanelDataService(testComparisonDataSource);
    const chartData = useTestMetricOverlaySeries(rawData, paletteType);
    const chartDef = useTestComparisonChartConfig(chartData, VARIANT_OVERLAY);

    return chartData ? <TestComparisonChart chartDef={chartDef} data={chartData} variant={VARIANT_OVERLAY} /> : null;
}

ServiceTestComparisonOverlayPanel.propTypes = panelPropTypes;

ServiceTestComparisonOverlayPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 250,
    minContentHeight: 150,
};

export default Panel({
    typeAlias: 'TestComparisonOverlayChart',
    catalogEntry: {
        category: PANEL_CATEGORIES.TEST,
        title,
        description: t`Before & after comparison of service test performance for a selected service test type, showing an overlay of the primary metric`,
        previewImage: COMPARISON_OVERLAY_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeComparisonFilterId, testTypeFilterId],
        optional: [agentFilterId, businessServiceFilterId, siteFilterId],
    },
})(ServiceTestComparisonOverlayPanel);
